// src/components/EarlyAccessCountdown.jsx
import React, { useEffect, useState } from "react";

const PREBOOK_DATE = new Date("2026-01-15T00:00:00");
const DELIVERY_DATE = new Date("2026-05-01T00:00:00");

function getRemaining(target) {
  const diff = target - new Date();
  if (diff <= 0) return null;

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    mins: Math.floor((diff / (1000 * 60)) % 60),
  };
}

export default function EarlyAccessCountdown() {
  const [prebook, setPrebook] = useState(getRemaining(PREBOOK_DATE));
  const [delivery, setDelivery] = useState(getRemaining(DELIVERY_DATE));

  useEffect(() => {
    const timer = setInterval(() => {
      setPrebook(getRemaining(PREBOOK_DATE));
      setDelivery(getRemaining(DELIVERY_DATE));
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-16 bg-[var(--aerzen-blue)]/5 text-center">
      <h2 className="text-3xl font-bold mb-10">
        Early Access Launch Timeline
      </h2>

      <div className="flex flex-col md:flex-row justify-center gap-8">
        {prebook && (
          <div className="bg-white rounded-2xl p-6 shadow">
            <div className="text-sm text-gray-500 mb-1">
              Early Access Pre-Booking Opens In
            </div>
            <div className="text-3xl font-bold text-[var(--aerzen-blue)]">
              {prebook.days}d {prebook.hours}h {prebook.mins}m
            </div>
            <div className="text-xs text-gray-500 mt-1">
              Launching 15 January 2026
            </div>
          </div>
        )}

        {delivery && (
          <div className="bg-white rounded-2xl p-6 shadow">
            <div className="text-sm text-gray-500 mb-1">
              Deliveries Begin In
            </div>
            <div className="text-3xl font-bold text-[var(--aerzen-blue)]">
              {delivery.days}d {delivery.hours}h {delivery.mins}m
            </div>
            <div className="text-xs text-gray-500 mt-1">
              From 01 May 2026
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
